import React, { useState, useEffect, useContext } from "react";

import * as S from "./styles";
import SkeletonListItem from "../SkeletonListItem";

import BorderForSelectNumberOfRecords from "../BorderForSelectNumberOfRecords";

import TableComponent from "./table";

import TablePagination from "@mui/material/TablePagination";
import { makeStyles } from "@mui/styles";

import { toast } from "react-toastify";

import { Context } from "../../context/globalContext";
import { buscarLog } from "../../services/logEntidade";

const useStyles = makeStyles({
  caption: {
    padding: 8,
    fontSize: "1.25rem",
  },
  toolbar: {
    "& > p:nth-of-type(2)": {
      fontSize: "1.25rem",
      color: "red",
      fontWeight: 600,
    },
  },
});

export default function ListLog({ entidadeId, nomeEntidade }) {
  const { setIsLoading, isLoading } = useContext(Context);
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const { pageLimit, setPageLimit } = useContext(Context);

  const [logs, setLogs] = useState([]);

  async function getData() {
    if (entidadeId) {
      setIsLoading(true);
      buscarLog(entidadeId, nomeEntidade, page, pageLimit)
        .then((response) => {
          if (
            response &&
            (response.status === 201 || response.status === 200)
          ) {
            setLogs(response.data.content);
            setPage(page || 0);
            setTotalPages(response.data.totalPages);
            setTotalElements(response.data.totalElements);
          } else if (!response) {
            setPage(page || 0);
            setLogs([]);
            setTotalPages(0);
            setTotalElements(0);
            toast.error("Erro ao buscar os logs.");
          }
        })
        .catch((err) => {
          setPage(page || 0);
          setTotalPages(0);
          setLogs([]);
          setTotalElements(0);
          setIsLoading(false);
          if (err?.response?.data?.message) {
            toast.error(err?.response?.data?.message);
          } else {
            toast.error("Erro ao buscar os logs.");
          }
        })
        .finally(() => setIsLoading(false));
    }
  }

  const reloadPage = (page) => {
    setPage(page);
    //history.replace(`?page=${page}`);
  };

  useEffect(() => {
    getData();
  }, [entidadeId, nomeEntidade, page, pageLimit]);

  const selectNumberRegistry = (item) => {
    setPageLimit(item.id);
  };

  if (entidadeId) {
    return (
      <>
        <S.CardHeader>
          <span>
            {`${totalElements} log${totalElements > 1 ? "s" : ""} cadastrado${
              totalElements > 1 ? "s" : ""
            }`}
          </span>
        </S.CardHeader>

        {isLoading ? (
          <SkeletonListItem />
        ) : (
          <S.TableWrapper>
            <TableComponent logs={logs} />
          </S.TableWrapper>
        )}
        {!isLoading && totalPages > 1 && (
          <S.RodaPe>
            <S.SelectPaginacaoWrapper>
              <S.SelectContainer>
                <BorderForSelectNumberOfRecords
                  selected={0}
                  handleSearch={selectNumberRegistry}
                  initialValue={pageLimit}
                />
              </S.SelectContainer>
            </S.SelectPaginacaoWrapper>
            {totalPages > 1 && (
              <TablePagination
                component="div"
                classes={{
                  toolbar: classes.toolbar,
                  caption: classes.caption,
                }}
                count={totalElements}
                page={page}
                labelDisplayedRows={({ from, to, count }) => {
                  return from + " - " + to + " de " + count;
                }}
                onPageChange={(p, newPage) => reloadPage(newPage)}
                rowsPerPageOptions={[]}
                rowsPerPage={pageLimit}
              />
            )}
          </S.RodaPe>
        )}
      </>
    );
  }

  return <></>;
}
